import { useContext } from 'react';
import _noop from 'lodash/noop';

import { AppContext, ModalContext } from 'commons-ui';
import { IUserV2HandlerParams } from 'models/settingsV2.model';
import useService from './utils/useService';

const useHandler = (params: IUserV2HandlerParams) => {
	const { setForceUpdate = _noop, rowData } = params;
	const { requestDeleteUser } = useService();
	const { showAlert, app } = useContext(AppContext);
	const { setModalConfig } = useContext(ModalContext);

	const onAgreeDeleteUser = async () => {
		setModalConfig({ isOpen: false });
		try {
			const response = await requestDeleteUser(app.appName, rowData);
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to delete user');
			}
			showAlert('User deleted successfully', { type: 'success' });
			setForceUpdate(true);
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while deleting this user', { type: 'error' });
		}
	};
	const onDisAgreeDeleteUser = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		onAgreeDeleteUser,
		onDisAgreeDeleteUser
	};
};

export default useHandler;
